// src/theme.js
import { extendTheme } from '@chakra-ui/react';
import brandColor from './styles/Brand';
import pageTokens from './styles/pageTokens';

const chakraTheme = extendTheme({
	colors: {
		brand: brandColor,
		page: {
			bg: pageTokens.bg,
			canvas: pageTokens.bgCanvas,
		},
	},
	config: {
		initialColorMode: 'light',
		useSystemColorMode: false,
	},
	fonts: {
		heading: `'Inter', system-ui, -apple-system, sans-serif`,
		body: `'Inter', system-ui, -apple-system, sans-serif`,
	},
	styles: {
		global: {
			body: {
				bg: pageTokens.bgCanvas,
				color: 'gray.800',
			},
		},
	},
	components: {
		Text: {
			baseStyle: {
				marginBottom: 0,
			},
		},
		Heading: {
			baseStyle: {
				color: 'gray.800',
				fontWeight: '600',
			},
			sizes: {
				page: {
					fontSize: { base: 'xl', md: '2xl' },
					lineHeight: '1.25',
				},
				section: {
					fontSize: { base: 'lg', md: 'xl' },
					lineHeight: '1.3',
				},
			},
		},
		Button: {
			defaultProps: {
				size: 'sm',
				colorScheme: 'teal',
			},
			baseStyle: {
				borderRadius: 'lg',
				fontWeight: 'semibold',
			},
		},
		Card: {
			baseStyle: {
				container: {
					borderRadius: 'xl',
					boxShadow: 'sm',
					borderWidth: '1px',
					borderColor: 'gray.200',
				},
			},
		},
	},
});

export default chakraTheme;
